import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useAuth } from './AuthProvider'

export function RequireAuth({ children, admin = false }: { children: ReactNode; admin?: boolean }) {
	const { user, loading } = useAuth()
	const location = useLocation()
	if (loading) return <div className="page-loading">Loading…</div>
	if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />
	if (admin && user.role !== 'admin') return <Navigate to="/" replace />
	return children
}
